import invert from 'invert-color'
import React from 'react'
import {Link} from 'react-router-dom'
import {isEmpty} from 'lodash'
import {titlecase} from 'admin/lib/format'

const PlanTag = ({plan}) => {
  if (isEmpty(plan)) return null

  let style = {}
  let color = plan.color || '#F5F5F5'
  style.backgroundColor = `${color}`
  style.color = invert(`${color}`, true)

  return (
    <span className='tag is-small' style={style}>
      {plan.name}
    </span>
  )
}

export default ({data, organisationID, onClick}) => (
  <table className='table is-striped is-hoverable is-fullwidth is-linked'>
    <colgroup>
      <col span='1' width='22%' />
      <col span='1' width='5%' />
      <col span='1' width='15%' />
      <col span='1' width='38%' />
      <col span='1' width='20%' />
    </colgroup>
    <thead>
      <tr>
        <th>Account name</th>
        <th>Status</th>
        <th>Plan</th>
        <th>Location</th>
        <th>Description</th>
      </tr>
    </thead>
    <tbody>
      {data.map((service, i) => (
        <tr
          key={i}
          onClick={e => {
            if (e.target.tagName.toLowerCase() !== 'a' && e.target.type !== 'checkbox') {
              e.preventDefault()
              onClick(service.id)
            }
          }}>
          <td>
            <Link to={`/orgs/${organisationID}/accounts/${service.account.id}`}>{service.account.displayName}</Link>
            {service.account.displayName !== service.account.contactFullName && !!service.account.contactFullName ? (
              <sub className='has-text-weight-semibold'>{service.account.contactFullName}</sub>
            ) : null}
          </td>
          <td>
            <span className={`tag is-small ${{active: 'is-success', inactive: 'is-danger'}[service.status]}`}>
              {titlecase(service.status)}
            </span>
          </td>
          <td>
            <PlanTag plan={service.plan} />
          </td>
          <td>
            {service.address}
            <sub>{service.coords?.join(', ')}</sub>
          </td>
          <td>{service.description}</td>
        </tr>
      ))}
    </tbody>
  </table>
)
